/* eslint-disable */

import { ApiRequestErrorType } from '../../types/api/api.types'
import { InternalServerError } from '../hooks/axios-instance'

export const getExceptionPayload = (
  ex: any,
):
  | ApiRequestErrorType
  | {
      message: string
      code: number
    } => {
  console.log('====================================')
  console.log({ ex })
  console.log('====================================')

  if ((ex as { code: string }).code === 'ERR_NETWORK') {
    return {
      message: 'Network Error. Please check your internet connection and try again.',
      code: -501,
    }
  }

  if (typeof ex !== 'object' || !ex) {
    return InternalServerError
  }

  const typeofException = ex as ApiRequestErrorType

  if (ex.hasOwnProperty('response') && ex.response?.data) {
    const data = typeofException.response.data
    const errorMessage =
      data.message ??
      data.description ??
      data.error ?? // Support Go auth service error field
      (typeof data === 'string' ? data : null)

    if (errorMessage && typeof errorMessage === 'string') {
      return {
        message: errorMessage,
        code: typeofException.response.status,
      }
    }
  }

  return InternalServerError
}
